export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "María González",
      role: "Diseñadora Gráfica",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20hispanic%20woman%20graphic%20designer%20smiling%2C%20clean%20background%2C%20professional%20portrait%20photography%20style&width=100&height=100&seq=avatar-1&orientation=squarish",
      rating: 5,
      text: "AbiSoft Explorer cambió completamente mi flujo de trabajo. Encuentro archivos 10 veces más rápido que antes. La vista previa de archivos es increíble para mi trabajo con imágenes y documentos de diseño."
    },
    {
      name: "Carlos Ruiz",
      role: "Desarrollador Full Stack",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20hispanic%20male%20software%20developer%20smiling%2C%20clean%20background%2C%20professional%20portrait%20photography%20style&width=100&height=100&seq=avatar-2&orientation=squarish",
      rating: 5,
      text: "La mejor inversión de $30 que he hecho. La organización automática y búsqueda por contenido me ahorra horas cada semana. Vale cada centavo y más."
    },
    {
      name: "Ana Martínez",
      role: "Fotógrafa Profesional",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20hispanic%20woman%20photographer%20smiling%2C%20clean%20background%2C%20professional%20portrait%20photography%20style&width=100&height=100&seq=avatar-3&orientation=squarish",
      rating: 5,
      text: "Interfaz hermosa y potente. Manejo miles de fotos y videos, y AbiSoft Explorer hace que todo sea súper fácil. No puedo volver a usar el explorador tradicional."
    },
    {
      name: "Roberto Silva",
      role: "Arquitecto",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20hispanic%20male%20architect%20smiling%2C%20clean%20background%2C%20professional%20portrait%20photography%20style&width=100&height=100&seq=avatar-4&orientation=squarish",
      rating: 5,
      text: "Perfecto para gestionar todos mis planos CAD y documentos de proyecto. La sincronización entre dispositivos es perfecta, trabajo desde cualquier lugar sin problemas."
    },
    {
      name: "Laura Fernández",
      role: "Consultora de Negocios",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20hispanic%20woman%20business%20consultant%20smiling%2C%20clean%20background%2C%20professional%20portrait%20photography%20style&width=100&height=100&seq=avatar-5&orientation=squarish",
      rating: 5,
      text: "La organización inteligente es una maravilla. Categoriza automáticamente mis documentos por cliente y proyecto. El soporte al cliente es excepcional también."
    },
    {
      name: "David Morales",
      role: "Productor Musical",
      avatar: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20hispanic%20male%20music%20producer%20smiling%2C%20clean%20background%2C%20professional%20portrait%20photography%20style&width=100&height=100&seq=avatar-6&orientation=squarish",
      rating: 5,
      text: "Manejo gigabytes de samples y proyectos musicales. AbiSoft Explorer hace que encontrar ese sample perfecto sea instantáneo. Revolucionó mi estudio."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50 dark:from-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-200 rounded-full text-sm font-medium mb-4">
            TESTIMONIOS
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Amado por miles de usuarios
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Descubre por qué profesionales de todas las industrias eligen AbiSoft Explorer para revolucionar su productividad
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-900 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 dark:border-gray-700 relative group"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 -left-4 w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center">
                <i className="ri-double-quotes-l text-white text-sm"></i>
              </div>

              {/* Rating */}
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* User Info */}
              <div className="flex items-center">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-gray-200 dark:border-gray-700"
                />
                <div>
                  <h4 className="font-semibold text-gray-900 dark:text-white">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 pt-16 border-t border-gray-200 dark:border-gray-700">
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">98%</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Satisfacción del cliente</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-600 dark:text-green-400 mb-2">15K+</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Usuarios activos</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-purple-600 dark:text-purple-400 mb-2">500M+</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Archivos organizados</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-orange-600 dark:text-orange-400 mb-2">24h</div>
            <div className="text-sm text-gray-600 dark:text-gray-400">Soporte promedio</div>
          </div>
        </div>
      </div>
    </section>
  );
}